<template>
  <div id="app">
    <loader />
    <Alert />
    <vue-extend-layouts />
    <footer class="site-footer">
      <span>2026 &copy; Data Energy Management Services</span>
      <span
        ><a href="https://dataenergy.co.uk/privacy-policy/" target="_blank"
          >Privacy Policy</a
        ></span
      >
      <span
        >w:
        <a href="https://dataenergy.co.uk/residents" target="_blank"
          >Residents Hub</a
        ></span
      >
    </footer>
  </div>
</template>

<script>
import VueExtendLayouts from "vue-extend-layout";
import Loader from "@/components/Loader.vue";
import { store } from "./store/";
import Alert from "@/components/Alert";
import { configService } from "@/services";

export default {
  name: "App",
  components: { Alert, VueExtendLayouts, Loader },
  created: function() {
    this.setHttp();
    this.setInstall();
    this.setGAUserAccess();
  },
  async mounted() {
    const config = await configService.getConfig();
    if (!config.data.chatWidget) {
      return;
    }

    //Display on production
    const script = document.createElement("script");
    script.src =
      "https://static.zdassets.com/ekr/snippet.js?key=46a4e1a6-8093-4977-b688-6e4be4470dba";
    script.id = "ze-snippet";
    document.body.appendChild(script);
  },
  methods: {
    setHttp() {
      this.$http.interceptors.response.use(undefined, function(err) {
        if (
          err.response &&
          err.response.status === 401 &&
          err.response.config &&
          !err.response.config.__isRetryRequest
        ) {
          store.dispatch("logout");
        }
        throw err;
      });
    },
    setInstall() {
      window.addEventListener("beforeinstallprompt", e => {
        e.preventDefault();
        store.dispatch("setInstallPrompt", { prompt: e });
      });
    },
    setGAUserAccess() {
      let standAlone = false;
      if (
        window.navigator.standalone === true ||
        window.matchMedia("(display-mode: standalone)").matches
      ) {
        standAlone = true;
        store.dispatch("isStandAlone");
      }
      this.$gtag.set("user_properties", {
        access_type: standAlone ? "PWA" : "Browser"
      });
    }
  }
};
</script>

<style lang="scss">
.app.login-template {
  background-color: #eee;
  padding-top: 30px;
  min-height: 100vh;
  padding-bottom: 30px;

  @media (min-width: 576px) {
    padding-top: 100px;
  }
}

.site-footer {
  bottom: 0px;
  text-align: left;
  background-color: #222;
  padding: 30px;
  color: white;
  font-size: 0.8rem;
  width: 100%;
  z-index: 1500;

  span {
    margin: 0px 10px;
    display: block;
  }

  a {
    color: white;
    &:visited {
      color: white;
    }
    &:hover {
      color: white;
    }
    &:active {
      color: white;
    }
  }

  @media (min-width: 576px) {
    text-align: center;
    padding: 10px;
    position: fixed;

    span {
      display: inline-block;
    }
  }
}
#app {
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.element {
  input {
    display: block;
    width: 94%;
    text-align: center;
    margin: 10px 3%;
    padding: 10px 5px;
  }
}

.login {
  font-family: "Open Sans", sans-serif;
  min-height: 400px;
  width: 350px;
  margin-top: auto;
  margin-bottom: auto;
  position: relative;
  display: flex;
  justify-content: center;

  .icon {
    position: absolute;
    top: -45px;
    background-color: white;
    border-radius: 50%;
    padding: 8px;
  }

  h1 {
    font-weight: bold;
    font-size: 1.7rem;
  }

  h2 {
    text-align: center;
    font-size: 1.4rem;
  }

  .disabled-button {
    cursor: not-allowed;
  }
}

.grecaptcha-badge {
  bottom: 45px !important;
}
</style>
